import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useTenantControlGetHook";

interface IAccessControlProps {
  allowedPermissions: any;
  children: any;
  renderNoAccess?: any;
}

const AccessControl = ({
  allowedPermissions,
  children,
  renderNoAccess,
}: IAccessControlProps) => {
  const { data, isLoading } = useGetHook({
    queryKey: [`permission`],
    url: `${APIS.PERMISSION}`,
    params: {},
  });

  const permissionsLists: any = data && data?.custom_permissions;
  let isAllowed: boolean = permissionsLists?.some(
    (permission: any) =>
      allowedPermissions.includes(permission) ||
      allowedPermissions.includes("no-permission-required")
  );
  if (isLoading) {
    return;
  }

  if (isAllowed) {
    return children;
  }

  return renderNoAccess ?? null;
};

export default AccessControl;
